import API from "@/api";

const state = {
  notifications: []
};

const getters = {
  count: state => state.notifications.length,
  unread: state => state.notifications.filter(n => !n.read).length
};

const mutations = {
  DELETE_NOTIFICATION(state, id) {
    state.notifications = state.notifications.filter(n => n.id !== id);
  },

  SET_NOTIFICATIONS(state, payload) {
    state.notifications = payload;
  },

  READ_NOTIFICATION(state, id) {
    const notification = state.notifications.find(n => n.id === id);
    if (notification) notification.read = true;
  }
};

const actions = {
  async deleteNotification({ commit }, id) {
    const { success } = await API.deleteNotification(id);
    if (!success) return;

    commit("DELETE_NOTIFICATION", id);
  },

  async getNotifications({ commit }) {
    commit("REQUEST_INCREMENT", null, { root: true });

    const { results } = await API.getNotifications();
    commit("SET_NOTIFICATIONS", results);

    commit("REQUEST_DECREMENT", null, { root: true });
  },

  async readNotification({ commit }, id) {
    const { success } = await API.readNotification(id);
    if (!success) return;

    commit("READ_NOTIFICATION", id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
